import React from 'react';
import loadable from '@loadable/component';
import Loading from '../components/Loading/Loading';
// import ProjectBanner from '../components/Banner/ProjectBanner/ProjectBanner';
// import Projects from "../components/Projects/Projects";
const Layout = loadable(() => import('../components/Layout/Layout'), {
  fallback: <Loading />,
});
const Projects = loadable(() => import('../components/Projects/Projects'), {
  fallback: <Loading />,
});
const ProjectBanner = loadable(
  () => import('../components/Banner/ProjectBanner/ProjectBanner'),
  {
    fallback: <Loading />,
  }
);
const projects = () => {
  return (
    <Layout>
      <ProjectBanner />
      <Projects />
    </Layout>
  );
};

export default projects;
